module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_9016.df812229.png";